<template lang="html">
  <div class="edit-list-type">
    <Overlay
      autoHeight
      width="x-small"
      :link="{name: 'list-type', params: {listTypeId: listTypeId}}">

      <Notification
        v-if="notification.active"
        :withinOverlay="true"
        :content="notification.content"
        :type="notification.type"/>

      <ListTypeForm @submit="submitListType" v-model="listType" :errors="errors" />
    </Overlay>
  </div>
</template>

<script>
import page from '@/mixins/page'
import notification from '@/mixins/notification'
import {readListTypeData, updateListTypeData} from '@/lib/list_types'

import Overlay from '@/components/Overlay'
import ListTypeForm from '@/components/forms/ListTypeForm'

export default {
  name: 'EditListType',

  mixins: [page, notification],

  components: {
    Overlay,
    ListTypeForm
  },

  props: {
    listTypeId: String
  },

  data() {
    return {
      listType: {},
      errors: {}
    }
  },

  methods: {
    submitListType() {
      updateListTypeData(this.listTypeId, this.listType)
        .then(({data}) => {
          this.triggerNotification('success', 'list type', 'updated')

          window.setTimeout(() => {
            this.$router.push({name: 'list-type', params: {listTypeId: data.id}})
          }, this.closeDelay)
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    },

    getData() {
      readListTypeData(this.listTypeId).then(({data}) => {
        this.listType = data
      })
    }
  },

  computed: {
    title() {
      return `Editing ${this.listType.name}`
    }
  },

  mounted() {
    this.getData()
  }
}
</script>
